export default __webpack_public_path__ + "static/wappan-edfabd85c20cdfb31c723b8aa8b44364.jpeg";